import View3D from "components/Product/View3D"
import PropTypes from "prop-types"
import React from "react"
import { Component } from "react"
import shop from "shop/shop"


import "style/ProductImages.scss"
import Slider from "components/Slider/Slider"
import ImageWithFallback from "components/ImageWithFallback"
import { Button } from "semantic-ui-react"

export default class ProductImages extends Component {

	render() {
		const { images, image, onClick, product } = this.props
		if (images.length === 0) {
			return <div className="ProductImages">
				<div className="">
					<div><ImageWithFallback fallback={"/image/placeholder.png"} src={image} /></div>
				</div>
			</div>
		}
		return (
			<div className="ProductImages">
				<div className="image-slider-container" style={{
					maxWidth: "500px",
					maxHeight: "500px",
					minWidth: "300px",
					minHeight: "300px",
					overflow: "hidden",
					objectFit: "contain",
					border: "none",
					display: "block",
					margin: "auto",
				}}>
					<Slider>
						{images.map(({ img_src_large }) => (
							<ImageWithFallback
								style={{
									maxWidth: "105px",
									maxHeight: "105px",
									minWidth: "105px",
									minHeight: "105px",
									overflow: "hidden",
									objectFit: "contain",
									border: "none",
								}}
								fallback={"/image/placeholder.png"}
								key={img_src_large}
								alt={`${product.title}`}
								title={`${product.title}`}
								src={img_src_large}
							/>
						))}
					</Slider>
				</div>

				<div className="product-images pt2 inline-images">
					{images.map(({ img_src_large, img_src_medium }) => (
						<div key={img_src_medium} className="pa2 inline-image">
							<table style={{ border: "none" }}>
								<tbody>
									<tr>
										<td className="tc " style={{ border: "none" }}>
											<ImageWithFallback
												style={{
													maxWidth: "105px",
													maxHeight: "105px",
													minWidth: "105px",
													minHeight: "105px",
													overflow: "hidden",
													objectFit: "contain",
													border: "none",
												}}
												fallback={"/image/placeholder.png"}
												className="img-thumbnail "
												alt={`${product.title}`}
												title={`${product.title}`}
												onClick={() => {
													onClick(img_src_large);
												}}
												src={img_src_medium}
											/>
										</td>
									</tr>
									<tr>
										<td className="tc pt2">
											<a
												download={`${product.article_nr}-${product.title}.jpg`} // works on same origin
												href={img_src_large}
												className="db ttu pt2 tc black-60 f7  "
											>
												<Button primary>Download</Button>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					))}

					{shop.config.plugin["view3D"] && (
						<View3D id={product.map_id} title={product.desc.short_des} />
					)}
				</div>
			</div>
		);
	}
}

ProductImages.propTypes = {
	images: PropTypes.any,
	image: PropTypes.any,
	onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductImages.js